import { BottomSheet, PrimaryButton } from '../premium';
import { defaultLevelForActivity, trackingCopy, type TrackingLevel } from '../../lib/cardioTracking';
import { WORKOUT_ACTIVITY_TYPES } from '../../lib/workoutActivity';

export function TrackingLevelSheet({
  open,
  activityType,
  onPick,
  onSkip,
}: {
  open: boolean;
  activityType: string;
  onPick: (level: TrackingLevel) => void;
  onSkip: () => void;
}) {
  const copy = trackingCopy(activityType);
  const recommended = defaultLevelForActivity(activityType);
  const label =
    WORKOUT_ACTIVITY_TYPES.find((a) => a.id === activityType)?.label ?? 'this activity';
  return (
    <BottomSheet open={open} onClose={onSkip} title={copy.title}>
      <p className="mb-4 text-sm text-[var(--text-muted)]">
        Only for {label}. Other workouts keep their own detail — a time-and-distance run
        does not change how you log lifting, and full lifting does not change your runs.
      </p>
      <div className="space-y-2">
        {copy.options.map((opt) => (
          <button
            key={opt.level}
            type="button"
            onClick={() => onPick(opt.level)}
            className="w-full rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3 text-left"
          >
            <div className="flex items-center gap-2">
              <div className="text-sm font-bold text-[var(--text-primary)]">{opt.label}</div>
              {opt.level === recommended && recommended !== 'quick' ? (
                <span className="rounded-full bg-sky-500/20 px-2 py-0.5 text-[10px] font-semibold text-sky-200">
                  Recommended
                </span>
              ) : null}
            </div>
            <div className="mt-0.5 text-xs text-[var(--text-muted)]">{opt.hint}</div>
          </button>
        ))}
      </div>
      <PrimaryButton className="mt-5" fullWidth onClick={onSkip}>
        {activityType === 'weightlifting' ? 'Skip — just sets' : 'Skip — just log time'}
      </PrimaryButton>
    </BottomSheet>
  );
}
